import React from "react";
import "./MapFilter.scss";
import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
import lowPrice from "@assets/icons/low-price.svg";
import mediumPrice from "@assets/icons/medium-price.svg";
import highPrice from "@assets/icons/high-price.svg";
import lowQuantity from "@assets/icons/low-quantity.svg";
import mediumQuantity from "@assets/icons/medium-quantity.svg";
import highQuantity from "@assets/icons/high-quantity.svg";

interface IMapFilter {
  selectedPriceFilter: number[];
  setSelectedPriceFilter: (nums: number[]) => void;
  selectedQuantityFilter: number[];
  setSelectedQuantityFilter: (nums: number[]) => void;
}

const MapFilter: React.FC<IMapFilter> = ({
  selectedPriceFilter,
  setSelectedPriceFilter,
  selectedQuantityFilter,
  setSelectedQuantityFilter,
}) => {
  
  const handleSelectPriceFilter = (idNumber: number) => {
    if (!selectedPriceFilter.includes(idNumber)) {
      setSelectedPriceFilter([...selectedPriceFilter, idNumber]);
    } else {
      const arrayTmp = [...selectedPriceFilter];
      const filteredSelected = arrayTmp.filter((item) => {
        return item != idNumber;
      });
      setSelectedPriceFilter(filteredSelected);
    }
  };

  const handleSelectQuantityFilter = (idNumber: number) => {
    if (!selectedQuantityFilter.includes(idNumber)) {
      setSelectedQuantityFilter([...selectedQuantityFilter, idNumber]);
    } else {
      const arrayTmp = [...selectedQuantityFilter];
      const filteredSelected = arrayTmp.filter((item) => {
        return item != idNumber;
      });
      setSelectedQuantityFilter(filteredSelected);
    }
  };

  return (
    <div className="MapFilter">
      <div className="map-filter-wrap">
        {(selectedPriceFilter.length > 0 ||
          selectedQuantityFilter.length > 0) && (
          <Button
            className="remove-btn"
            icon={<DeleteOutlined />}
            danger
            onClick={() => {
              setSelectedPriceFilter([]);
              setSelectedQuantityFilter([]);
            }}
          />
        )}
        <div className="map-filter-price">
          <div
            className={`filter-button filter-good ${
              selectedPriceFilter.includes(1) && "selected"
            }`}
            onClick={() => handleSelectPriceFilter(1)}
          >
            <img src={lowPrice} width={32} />
          </div>
          <div
            className={`filter-button filter-medium ${
              selectedPriceFilter.includes(2) && "selected"
            }`}
            onClick={() => handleSelectPriceFilter(2)}
          >
            <img src={mediumPrice} width={32} />
          </div>
          <div
            className={`filter-button filter-high ${
              selectedPriceFilter.includes(3) && "selected"
            }`}
            onClick={() => handleSelectPriceFilter(3)}
          >
            <img src={highPrice} width={32} />
          </div>
        </div>
        <div className="map-filter-quantity">
          <div
            className={`filter-button ${
              selectedQuantityFilter.includes(1) && "selected"
            }`}
            onClick={() => handleSelectQuantityFilter(1)}
          >
            <img src={lowQuantity} width={32} />
          </div>
          <div
            className={`filter-button ${
              selectedQuantityFilter.includes(2) && "selected"
            }`}
            onClick={() => handleSelectQuantityFilter(2)}
          >
            <img src={mediumQuantity} width={32} />
          </div>
          <div
            className={`filter-button ${
              selectedQuantityFilter.includes(3) && "selected"
            }`}
            onClick={() => handleSelectQuantityFilter(3)}
          >
            <img src={highQuantity} width={32} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapFilter;
